import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermGuidelineCategory from '@/components/TermGuidelineCategory';

const QualityGuidelineFigureHobbyPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';
  const imageGridClass = `w-full grid ${isMobile ? 'grid-cols-1 gap-5' : 'grid-cols-2 gap-[30px]'}`;

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}

      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px]">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="text-black text-[40px] font-bold leading-[60px]">クオリティガイドライン - フィギュア・ホビー</div>
            <div className="h-[3px] w-full bg-[#e4e4e4]" />
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="text-black text-2xl font-bold leading-9">出品条件</div>
            </div>
            <div className="w-full text-black text-base leading-7">
              フィギュア・ホビーに該当する商品は「新品」のみ出品可能です。<br />
              以下の条件をすべて満たしている商品が対象です。<br />
              ・新品、未使用、未開封である<br />
              ・商品本体や付属品に汚損や破損がみられない
            </div>
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="text-black text-2xl font-bold leading-9">POP MARTの出品について</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full text-black text-base leading-7">
                POP MARTの商品は「新品」での出品が可能です。<br />
                なお、商品本体が封入されている内袋の形状については、シリーズや販売時期によって異なる場合がございます。<br />
                また、開封や保管の過程で生じ得るボックスの軽微なダメージは基準内と判断しておりますが、下記画像のような大きな破れ等が確認された場合には、購入者へ取引の継続可否をご確認いただく場合がございます。あらかじめご了承ください。
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="w-full text-black text-base leading-7">すべての出品に共通するルールや、出品情報に関する詳細については、以下のページもあわせて必ずご確認ください。</div>
                <Link
                  to={`/terms/guideline_listing${location.search}`}
                  className="w-full text-[#00b8f9] text-base underline leading-7 hover:text-[#0099d6]"
                >
                  出品ガイドライン
                </Link>
              </div>
            </div>
            <div className={imageGridClass}>
              <img
                className="w-full h-auto"
                src="/images/terms/guideline_figure_hobby_01.jpg"
                alt="透明パックの大きな破れ"
              />
              <img
                className="w-full h-auto"
                src="/images/terms/guideline_figure_hobby_02.jpg"
                alt="カード本体の折れ"
              />
            </div>
            <div className={imageGridClass}>
              <img
                className="w-full h-auto"
                src="/images/terms/guideline_figure_hobby_03.jpg"
                alt="透明パックの大きな破れの例"
              />
            </div>
          </div>

          <TermGuidelineCategory />
        </div>
      </div>

      {!isMobile && <Footer />}
    </div>
  );
};

export default QualityGuidelineFigureHobbyPage;
